<div class="l-container  u-margin-top-xl">
  <div class="l-grid  l-grid--horizontal-center">
    <div class="l-grid__unit  l-grid__unit--9of12@large">

      <div class="c-card">
        <div class="c-card__body">
          <div class="l-container">
            <div class="c-wysiwyg">
              <h2>{{ 'MAINTENANCE.maintenance' | translate }}</h2>
              <p>
                {{ 'MAINTENANCE.info' | translate }}
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

</div>





